<app-layout>
    <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.launchpads')">Launchpads</inertia-link>
        - {{ subTitle }}
    </h1>
    <div class="bg-white rounded shadow overflow-hidden lg:w-1/2">
        <form @submit.prevent="submit">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                <div class="pr-6 pb-8 w-full">
                    <div class="font-weight-bold text-xl border-b mb-2 pb-4 font-medium">Launchpad Information</div>
                </div>

                <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full" label="Launchpad Name" />
                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">Currency:</label>
                    <t-rich-select
                        :options="currencies"
                        v-model="form.currency_id"
                        placeholder="Select currency"
                        value-attribute="id"
                        text-attribute="name"
                    >
                        <template
                            slot="label"
                            slot-scope="{ className, option, query }"
                        >
                            <div class="flex">
                                <div class="flex flex-col">
                                    <span>{{ option.text }}</span>
                                </div>
                            </div>
                        </template>
                    </t-rich-select>
                    <div v-if="errors.currency_id" class="form-error text-red-400">{{ errors.currency_id }}</div>
                </div>

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">Network:</label>
                    <t-rich-select
                        v-model="form.network_id"
                        :options="networks"
                        placeholder="Select network"
                        value-attribute="id"
                        text-attribute="name"
                    >
                        <template
                            slot="label"
                            slot-scope="{ className, option, query }"
                        >
                            <div class="flex">
                                <div class="flex flex-col">
                                    <span>{{ option.text }}</span>
                                </div>
                            </div>
                        </template>
                    </t-rich-select>
                    <div v-if="errors.network_id" class="form-error text-red-400">{{ errors.network_id }}</div>
                </div>

                <textarea-input v-model="form.description" :error="errors.description" class="pr-6 pb-8 w-full h-150" label="Launchpad Description" />

                <text-input v-model="form.rate" :error="errors.rate" class="pr-6 pb-8 w-full" label="Rate (e.g. How many tokens will be sold for 1 BNB/ETH)" />

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">Start Time (UTC):</label>
                    <t-datepicker
                        v-model="form.start_time"
                        :timepicker="true"
                        dateFormat="Y-m-d H:i:00"
                        userFormat="Y-m-d H:i:00"
                    />
                </div>

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">End Time (UTC):</label>
                    <t-datepicker
                        v-model="form.end_time"
                        :timepicker="true"
                        dateFormat="Y-m-d H:i:00"
                        userFormat="Y-m-d H:i:00"
                    />
                </div>

                <text-input v-model="form.soft_cap" :error="errors.soft_cap" class="pr-6 pb-8 w-full lg:w-1/2" label="Soft Cap in BNB or ETH" />
                <text-input v-model="form.hard_cap" :error="errors.hard_cap" class="pr-6 pb-8 w-full lg:w-1/2" label="Hard Cap in BNB or ETH" />

                <text-input v-model="form.min_buy" :error="errors.min_buy" class="pr-6 pb-8 w-full lg:w-1/2" label="Minimum buy amount in BNB or ETH" />
                <text-input v-model="form.max_buy" :error="errors.max_buy" class="pr-6 pb-8 w-full lg:w-1/2" label="Maximum buy amount in BNB or ETH" />

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label block mr-2 mb-3">Launchpad Active</label>
                    <t-toggle v-model="form.status" />
                </div>

            </div>
            <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                <button v-if="isEdit" class="focus:outline-none text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Launchpad</button>
                <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">{{ actionButtonTitle }}</loading-button>
            </div>
        </form>
    </div>
</app-layout>
